export enum UserRole {
  Talent = 'talent',
  Manager = 'manager',
  OrganizationAdmin = 'organization_admin',
  SuperAdmin = 'super_admin',
  Contact = 'contact',
}
